import {Form} from "./Form"
import {AiOutlineMail} from 'react-icons/ai'
import {BsTelephone} from 'react-icons/bs'
import {CgWebsite} from 'react-icons/cg'
import {FaFacebookF} from 'react-icons/fa'
import {IoLogoWhatsapp, IoLogoInstagram, IoLogoYoutube, IoLogoTwitter, IoLogoTiktok} from 'react-icons/io5'
import {AiOutlineYoutube} from 'react-icons/ai'
import React from "react";

const Contact = () => {
    return (
        <section
            className="w-full  lg:px-16 md:text-2xl lg:mt-0 flex flex-wrap flex-col lg:flex-row items-center lg:items-end justify-around gap-16"
            id="contact">

            {/* Address */}
            <div
                className="w-full h-[620px] pt-20  bg-[url('/assets/cuadricepsRaul.png')] bg-cover bg-no-repeat">
                {/* <img className="absolute -z-10 w-full" src="/assets/cropped-photo-of-amazing-young-sports-woman-body.png" alt="" /> */}
                <h2 className='text-3xl mt-10  font-black uppercase text-left ml-10 lg:text-left'>Contacto</h2>

                <div className="px-10  lg:px-16  ">
                    <ul className="mt-4">
                        <li className="mt-2 flex   items-center gap-3"><span><AiOutlineMail
                            size={40}/></span><span
                            className={'bg-bgBlack rounded-xl py-1 px-2'}>rpspreparations@hotmail.es</span>
                        </li>
                        <li className="mt-5 flex   items-center gap-3"><span><IoLogoWhatsapp
                            className="text-white"
                            size={40}/></span><span
                            className={'bg-bgBlack rounded-xl py-1 px-2'}>600 80 31 85</span>
                        </li>
                    </ul>
                    <p className="mt-[200px] text-center  font-bold ml-10">
                        SÍGUEME PARA SABER MAS DE MI
                    </p>
                    {/* Social Links */}
                    <ul className="mt-4 flex ml-5 item gap-4 justify-center">
                        <li className="cursor-pointer">
                            <a href={"https://api.whatsapp.com/send/?phone=34600803185&text&type=phone_number&app_absent=0"}
                               className="w-[50px] h-[50px] rounded-full bg-white hover:bg-sbPallet-accent flex items-center justify-center group ease-in duration-100">
                                <IoLogoWhatsapp
                                    className="text-black group-hover:text-white  ease-in duration-100"
                                    size={40}/>
                            </a>
                        </li>

                        {/*<li className="cursor-pointer">
              <div className="w-8 h-8 rounded-full bg-sbPallet-accent hover:bg-white flex items-center justify-center group ease-in duration-100">
                <FaFacebookF className="text-black group-hover:text-sbPallet-accent ease-in duration-100" size={20} />
              </div>
            </li>*/}
                        <li className="cursor-pointer">
                            <a href={'https://instagram.com/raulperez.coach?igshid=MzRlODBiNWFlZA=='} className="w-[50px] h-[50px]
               rounded-full  bg-white hover:bg-sbPallet-accent flex items-center justify-center group ease-in duration-100">
                                <IoLogoInstagram
                                    className="text-black group-hover:text-white ease-in duration-100"
                                    size={40}/>
                            </a>
                        </li>
                        {/*<li className="cursor-pointer">
                            <a className="w-[50px] h-[50px] rounded-full bg-white hover:bg-sbPallet-accent flex items-center justify-center group ease-in duration-100">
                                <AiOutlineYoutube
                                    className="text-black group-hover:text-white ease-in duration-100"
                                    size={40}/>
                            </a>
                        </li>*/}
                        <li className="cursor-pointer">
                            <a href={'https://www.tiktok.com/@raulperezcoach?_t=8eaBjMk2dyi&_r=1'} className="w-[50px] h-[50px] rounded-full bg-white hover:bg-sbPallet-accent flex items-center justify-center group ease-in duration-100">
                                <img className={''} src={'assets/icons/tiktok.png'}/>
                            </a>
                        </li>
                        {/*<li className="cursor-pointer">
              <div className="w-8 h-8 rounded-full bg-sbPallet-accent hover:bg-white flex items-center justify-center group ease-in duration-100">
                <IoLogoTiktok className="text-black group-hover:text-sbPallet-accent ease-in duration-100" size={20} />
              </div>
            </li>
            <li className="cursor-pointer">
              <div className="w-8 h-8 rounded-full bg-sbPallet-accent hover:bg-white flex items-center justify-center group ease-in duration-100">
                <IoLogoTwitter className="text-black group-hover:text-sbPallet-accent ease-in duration-100" size={20} />
              </div>
            </li>*/}
                    </ul>
                </div>
            </div>
            {/* Map */}
            {/*<div className="">
                <h2 className="text-lg font-black">Find us on the map:</h2>
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3657.1973529954835!2d-46.6564943!3d-23.5613545!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce59c8da0aa315%3A0xd59f9431f2c9776a!2sAv.%20Paulista%2C%20S%C3%A3o%20Paulo%20-%20SP!5e0!3m2!1spt-BR!2sbr!4v1659820599906!5m2!1spt-BR!2sbr"
                    className="w-[300px] lg:w-[324px] h-[230px] lg:h-[372px] mt-9 mb-16"
                    frameBorder="0"
                    style={{border: 0}}
                    allowFullScreen=""
                    aria-hidden="false"
                    tabIndex="0"
                />
                <a className='w-40 p-2 text-xs text-center uppercase border rounded-lg hover:font-bold hover:bg-sbPallet-accent hover:border-sbPallet-accent ease-in-out duration-200'
                   href="#">Request a call</a>
            </div>*/}
        </section>
    )
}

export default Contact